import React from "react"
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect
} from "react-router-dom"
// SHARED
import Card from "../core/Card"
// LOCAL
import "./Account.css"
import Menu from "./menu/Menu.js"

import Profile from "./profile/Profile.jsx"
import FavoriteTrips from "./favorite-trips/FavoriteTrips"
import FavoritePlaces from "./favorite-places/FavoritePlaces"
import DataExports from "./data-export/DataExports"
import BusinessLines from "./business-lines/BusinessLines"
import Tracker from "./tracker/Tracker"
import TaxCenter from "./tax-center/TaxCenter"
import WorkHours from "./work-hours/WorkHours"
import Vehicles from "./vehicles/Vehicles"
import BankCard from "./bank-card"
import FavTxns from "./favorite-transactions"
import Integrations from "./integrations"

const Account = ({ match }) => (
  <div className="Account">
    <div className="Main">
      {/* <Redirect to="/account/profile"/> */}
      <Route path={`${match.url}/profile`} component={Profile} />
      <Route path={`/account/business-lines`} component={BusinessLines} />
      <Route path={`/account/data-exports`} component={DataExports} />
      <Route path={`/account/tracker`} component={Tracker} />
      <Route path={`/account/favorite-trips`} component={FavoriteTrips} />
      <Route path={`/account/favorite-places`} component={FavoritePlaces} />
      <Route path={`/account/tax-center`} component={TaxCenter} />
      <Route path={`/account/work-hours`} component={WorkHours} />
      <Route path={`/account/vehicles`} component={Vehicles} />
      <Route path={`/account/bank-card`} component={BankCard} />
      <Route path={`/account/favorite-transactions`} component={FavTxns} />
      <Route path={`/account/integrations`} component={Integrations} />
      {/* <Route exact path={`/account`} component={()=><Menu forceDisplay/>}/> */}
    </div>
  </div>
)

export default Account



// WEBPACK FOOTER //
// ./src/account/Account.js